import React from 'react';
import { PageContainer } from '@/components/containers/PageContainer/PageContainer';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Label from '@/components/form/Label/Label';
import NewSpaceCardShortVersion from '@/components/reusable/NewSpaceCardShortVersion/NewSpaceCardShortVersion';
import './SpacesList.scss';

const SpacesDataRow = props => {
  const { spacesData, goToSpacesPreList } = props;
  const chunkArray = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };

  const groupedSpaces = chunkArray(spacesData || [], 4);
  const containerClass = 'bgWhite padlr20 gap-20 margb20 m-padlr0 format100 m-flex-column';

  return (
    <>
      {groupedSpaces.map((group, groupIndex) => (
        <FlexContainer
          key={groupIndex}
          className={containerClass}
          justifyBetween
        >
          {group.map((space, index) => (
            <NewSpaceCardShortVersion
              key={index}
              spaceInfo={space}
              handleDetailButton={() => goToSpacesPreList(space)}
              priceAndCapacityDetails
            />
          ))}
          {groupIndex === groupedSpaces.length - 1 &&
            group.length < 4 &&
            Array.from({ length: 4 - group.length }).map((_, emptyIndex) => (
              <FlexContainer
                className={'padtb20 flex-column justify-between format100'}
                key={emptyIndex}
              ></FlexContainer>
            ))}
        </FlexContainer>
      ))}
    </>
  );
};

const SpacesList = props => {
  const {
    customTitle,
    buttonTitle,
    isShowButton,
    spacesData,
    extraClass,
    buttonMethod,
  } = props;
  const navigate = useNavigate();

  const lenguage = useSelector(state => state.lenguage?.lang);

  const goToSpacesPreList = spaceData => {
    //navigate('/lista-espacios');
    navigate(
      lenguage === 'ES'
        ? '/confirmar-reservacion/' + spaceData?.relationship_title + '/' + spaceData?.id_relationship
        : '/confirm-reservation/' + spaceData?.relationship_title + '/' + spaceData?.id_relationship,
      {
        state: { spaceData },
      },
    );
  };
  const goToSpacesList = () => {
    navigate(lenguage === 'ES' ? '/espacios' : '/spaces');
  };

  return (
    <PageContainer className={'bgWhite'}>
      <FlexContainer
        className={'flex-column mySpacesList bgWhite format100 ' + extraClass}
        justifyBetween
        alignItemsStart
      >
        {customTitle && (
          <Label type="text-22 marglr20 m-marglr0 padtb30">
            <strong>{customTitle}</strong>
          </Label>
        )}
        <SpacesDataRow spacesData={spacesData} goToSpacesPreList={goToSpacesPreList} />

        {isShowButton && (
          <FlexContainer className={'flex-column width100'} alignItemsCenter>
            <button
              onClick={() => buttonMethod()}
              className={
                'pointer border-rad8px margtb20 grayShadow16 padlr40 padtb10 text-14 borderGray5'
              }
            >
              {buttonTitle}
            </button>
          </FlexContainer>
        )}
      </FlexContainer>
    </PageContainer>
  );
};

export default SpacesList;
